import { createAsyncThunk } from "@reduxjs/toolkit";
import { getEvents as getEventsAPI, createEvent, updateEvent, deleteEvent, deleteEventsByUser } from "../../helpers/api_method";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const getEvents = createAsyncThunk("calendar/getEvents", async () => {
    try {
        const response = await getEventsAPI();
        // Handle the API response format
        if (response && response.data) {
            return response.data;
        }
        return response || [];
    } catch (error: any) {
        console.error("Error fetching events:", error);
        return [];
    }
});

export const addEvents = createAsyncThunk("calendar/addEvents", async (event: any) => {
    try {
        const response = await createEvent(event);
        const data = response;
        if (data && data.data) {
            toast.success("Event Added Successfully", { autoClose: 2000 });
            return data.data;
        }
        toast.success("Event Added Successfully", { autoClose: 2000 });
        return data;
    } catch (error: any) {
        console.error("Error adding event:", error);
        toast.error("Event Added Failed", { autoClose: 2000 });
        throw error;
    }
});

export const updateEvents = createAsyncThunk("calendar/updateEvents", async (event: any) => {
    try {
        const response = await updateEvent(event.id, event);
        const data = response;
        if (data && data.data) {
            toast.success("Event updated Successfully", { autoClose: 2000 });
            return data.data;
        }
        toast.success("Event updated Successfully", { autoClose: 2000 });
        return data;
    } catch (error: any) {
        console.error("Error updating event:", error);
        toast.error("Event updated Failed", { autoClose: 2000 });
        throw error;
    }
});

export const deleteEvents = createAsyncThunk("calendar/deleteEvents", async (event: any) => {
    try {
        const response = await deleteEvent(event.id || event);
        toast.success("Event deleted Successfully", { autoClose: 2000 });
        return event.id || event; // Return the event ID for proper removal
    } catch (error: any) {
        console.error("Error deleting event:", error);
        toast.error("Event deleted Failed", { autoClose: 2000 });
        throw error;
    }
});

export const deleteEventsByUserId = createAsyncThunk("calendar/deleteEventsByUserId", async (userId: any) => {
    try {
        const response = await deleteEventsByUser(userId);
        return userId;
    } catch (error: any) {
        console.error("Error deleting events for user:", error);
        throw error;
    }
});